import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { CuentasJardinModel, CuentasModel, Region, ResponseCuentasModel } from 'src/app/model/Cuentas.model';
import { ResponseJardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-plan-gestion-convivencia-admin',
  templateUrl: './plan-gestion-convivencia-admin.component.html',
  styleUrls: ['./plan-gestion-convivencia-admin.component.css']
})
export class PlanGestionConvivenciaAdminComponent implements OnInit {

  @Input() region : Region;
  simulacion:boolean=false;
  displayedColumns=[];
  filterValues = {};
  filterSelectObj = [];
  tipoCampos = [];
  arrayComunas = [];
  regiones = [];
  programas = [];
  dataSource: MatTableDataSource<CuentasJardinModel>;
  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  pageEvent: PageEvent;
  pageIndex:number;
  length:number;
  getSelect = false;
  apiEndpoint = environment.apiEndpoint;
  columnNames = [
    { id: 'region', value: 'region' }, 
    { id: 'comuna', value: 'comuna' }, 
    { id: 'modalidad', value: 'modalidad' }, 
    { id: 'programa', value: 'programa' }, 
    { id: 'codigo', value: 'codigo' }, 
    { id: 'jardin', value: 'jardin' }, 
    { id: 'fecha_elaboracion', value: 'fecha_elaboracion' }, 
    { id: 'fecha_actualizacion', value: 'fecha_actualizacion' }, 
    { id: 'estado', value: 'estado' }, 
    { id: 'acciones', value: 'acciones' },
  ];
  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @Input() infoSelectJardin: CuentasModel;
  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;

  url:string;
  urlSafe: SafeResourceUrl;

  constructor(
    private api: apiService,    
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private modal: NgbModal,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.simulacion=false;
    this.spinner.show();
    this.palabraClave = "";
    this.idComuna = 0;
    this.idPrograma = 0;
    this.idRegion = 0;
    this.getSelectCuentas(); 
  }

  getSelectCuentas(){
    this.api.API_POST_getSelectCuentas().subscribe((response: ResponseCuentasModel) => {
      this.infoSelectJardin = response.payload
      this.regiones = this.infoSelectJardin.regiones;
      this.programas = this.infoSelectJardin.programas;
      if(this.region != null){
        this.idRegion = this.region.idRegion;
        this.seleccionarRegion(this.region.idRegion);
      }
      this.getServerData(); 
      this.spinner.hide();
    },
    (err) => {
      console.log(err)
    })
  }
  
  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null );
  }


  public callData(event?:PageEvent){
    this.spinner.show();
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.api.API_POST_getPlanGestionConvivenciaDetalle(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: any) => {
      this.displayedColumns = this.columnNames.map(x => x.id);
      this.dataSource = new MatTableDataSource<CuentasJardinModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      this.length = response.payload.total;

      setTimeout(() => {
        
        this.dataSource.paginator = this.paginator;
        this.spinner.hide();
      }, 1000);
        
    },
    (err) => {
      console.log("error"+err)
    })
  }



  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }
  
  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }


  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }

  simular(jardin : any){
    this.spinner.show();
    this.api.API_POST_obtenerJardinPorRBD(parseInt(jardin.codigo)).subscribe((response:ResponseJardinModel) => {
      this.api.dataJardin = response.payload;
      this.simulacion=true;
      this.spinner.hide();
    },
    (err) => { 
      console.log(err)
      this.spinner.hide();
      Swal.fire({
        title: 'Error!',
        text: 'Error al Cargar Jardín',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    })
  }

  close(){
    this.modal.dismissAll();
  }

  imprimir(id){
    this.url = this.apiEndpoint + "planGestionConvivencia/imprimir/" + id;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }
}

